import React from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import { TagIcon, UtilitiesIcon } from '../../../icons/icons';
import UtilitiesBox from './UtilitiesBox';
import TenureInfo from './TenureInfo';
import UtilityInfo from './UtilityInfo';
import FloodErosion from './FloodErosion';
import RightsInfo from './RightsInfo';
import CostsAssociatedBox from './CostsAssociatedBox';
import "./Utilities.scss";

const Utilities = (props) => {
  // Check if at least one value exists in TenureInfo
  const hasTenureInfo = 
  (props.sellingInfo?.tenure?.type && props.searchType === "sales") ||
  (props.extra?.groundRent !== null && props.extra?.groundRent !== 0) ||
  (props.extra?.serviceCharge !== 0 && props.extra?.serviceCharge !== null) ||
  (props.lettingInfo?.deposit?.amount !== 0 && props.lettingInfo?.deposit?.amount !== null && props.searchType === "lettings") ||
  (props.lettingInfo?.minimumTerm !== 0 && props.searchType === "lettings");

  // Check if there's data for any of the Utility, FloodErosion, or RightsInfo components
  const hasUtilitiesRightsRestrictions = 
  // Check for Utility Data
  (props.utilityData?.electricity?.type ?? '') !== '' || 
  (props.utilityData?.water?.type ?? '') !== '' || 
  (props.utilityData?.heating?.length ?? 0) > 0 || 
  (props.utilityData?.internet?.type?.length ?? 0) > 0 || 
  (props.utilityData?.water?.sewerage ?? '') !== '' || 
  (props.utilityData?.mainHeating?.length ?? 0) > 0 || 
  (props.accessibility?.length ?? 0) > 0 ||
  
  // Check for Flood Erosion Data
  (props.floodErosion?.floodedInLastFiveYears ?? false) || 
  (props.floodErosion?.floodDefences ?? '') !== '' || 
  (props.floodErosion?.floodSources?.length ?? 0) > 0 || 
  (props.floodErosion?.lastFlood ?? '') !== '' || 
  
  // Check for Rights and Restrictions Data
  (props.rightsRestrictions?.listed ?? false) || 
  (props.rightsRestrictions?.restrictions ?? '') !== '' || 
  (props.rightsRestrictions?.easementsOrServitudesOrWayleaves ?? '') !== '' || 
  (props.rightsRestrictions?.rightOfWay ?? false);


  return (
    <div className="utilities-wrapper">
      <Container>
        <Row>
          <Col lg={6} className="tenure-wrap">
            {hasTenureInfo && (
              <UtilitiesBox title="Tenure" icon={TagIcon}>
                <TenureInfo
                  sellingInfo={props.sellingInfo}
                  extra={props.extra}
                  lettingInfo={props.lettingInfo}
                  searchType={props.searchType}
                  propertyPrice={props?.propertyPrice}
                />
              </UtilitiesBox>
            )}
            <CostsAssociatedBox />
          </Col>
          {hasUtilitiesRightsRestrictions && (
          <Col lg={6} className="utilities-wrap">
            <UtilitiesBox title="Utilities, rights & restrictions" icon={UtilitiesIcon}>
              <UtilityInfo utilityData={props?.utilityData} accessibility={props?.accessibility} /> 
              <FloodErosion floodErosion={props?.floodErosion} />
              <RightsInfo rightsRestrictions={props?.rightsRestrictions} />             
            </UtilitiesBox>
          </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}

export default Utilities;